import { getDefaultLocale } from 'utils/locale';
const SUPPORTED_LOCALES = ['pl', 'en'];

const useLocale = () => {
  const stored = localStorage.getItem('locale');
  return SUPPORTED_LOCALES.includes(stored) ? stored : getDefaultLocale();
};

export default useLocale;
